(() => {
  'use strict';
  if (window.musFavouritesLoaded) return;
  const config = document.getElementById('MusFavouritesConfig');
  if (!config) return;
  window.musFavouritesLoaded = true;
  const strings = JSON.parse(config.textContent);
  const key = 'mus_favourites_v1';
  const root = window.Shopify?.routes?.root || '/';
  const status = document.querySelector('[data-mus-fav-status]');
  const page = document.querySelector('[data-mus-favourites-page]');
  let toastTimer, renderVersion = 0, visible = 12;
  const identity = item => String(item.id);
  function read() {
    try {
      const items = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(items)) return [];
      const seen = new Set();
      const unique = items.filter(item => {
        if (!item || !/^\d+$/.test(String(item.id)) || !/^[a-z0-9][a-z0-9_-]*$/i.test(item.handle) || !/^(\d+)?$/.test(String(item.variant || ''))) return false;
        const id = identity(item);
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      }).slice(0, 200);
      if (unique.length !== items.length) {
        try { localStorage.setItem(key, JSON.stringify(unique)); } catch {}
      }
      return unique;
    } catch { return []; }
  }
  function announce(message) {
    clearTimeout(toastTimer);
    status.textContent = message;
    status.classList.add('is-visible');
    toastTimer = setTimeout(() => status.classList.remove('is-visible'), 4000);
  }
  function save(items) {
    try { localStorage.setItem(key, JSON.stringify(items)); return true; }
    catch { announce(strings.storage_error); return false; }
  }
  function itemFor(button) {
    let variant = button.dataset.variantId || '';
    if (button.hasAttribute('data-track-variant')) {
      const form = button.closest('form') || button.closest('[data-mus-product-root]')?.querySelector('#MusProductForm');
      variant = form?.querySelector('[name="id"]')?.value || '';
    }
    return { id: button.dataset.productId, handle: button.dataset.handle, variant, title: button.dataset.productTitle };
  }
  function sync() {
    const items = read();
    const saved = new Set(items.map(identity));
    document.querySelectorAll('[data-mus-favourite]').forEach(button => {
      const item = itemFor(button);
      const active = saved.has(identity(item));
      button.hidden = false;
      button.disabled = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? strings.remove : strings.add);
      const label = button.querySelector('[data-mus-fav-label]');
      if (label) label.textContent = active ? strings.saved : strings.add;
    });
    document.querySelectorAll('[data-mus-fav-link]').forEach(link => {
      link.hidden = false;
      link.setAttribute('aria-label', `${strings.title} (${items.length})`);
    });
    document.querySelectorAll('[data-mus-fav-count]').forEach(counter => {
      counter.textContent = String(items.length);
      counter.hidden = items.length === 0;
    });
  }
  function productUrl(item) {
    const url = new URL(`${root}products/${encodeURIComponent(item.handle)}`, location.origin);
    if (item.variant) url.searchParams.set('variant', item.variant);
    return url;
  }
  function errorCard(item, missing) {
    const card = document.createElement('article');
    card.className = 'mus-favourite-card mus-favourite-card--error';
    card.dataset.musFavItem = '';
    const heading = document.createElement('h2');
    heading.textContent = item.title || strings.unavailable;
    const message = document.createElement('p');
    message.textContent = missing ? strings.unavailable : strings.load_error;
    const link = document.createElement('a');
    link.href = productUrl({...item, variant: ''}).href;
    link.textContent = strings.view;
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.dataset.musFavRemove = '';
    remove.textContent = strings.remove;
    card.append(heading, message, link, remove);
    if (!missing) {
      const retry = document.createElement('button');
      retry.type = 'button'; retry.dataset.musFavRetry = ''; retry.textContent = strings.retry;
      card.append(retry);
    }
    return card;
  }
  async function renderPage() {
    if (!page) return;
    const version = ++renderVersion;
    const items = read();
    const grid = page.querySelector('[data-mus-fav-grid]');
    page.querySelector('[data-mus-fav-empty]').hidden = items.length !== 0;
    page.querySelector('[data-mus-fav-summary]').textContent = items.length ? `${items.length} ${items.length === 1 ? strings.item : strings.items}` : '';
    const more = page.querySelector('[data-mus-fav-more]');
    more.hidden = items.length <= visible;
    grid.replaceChildren();
    grid.setAttribute('aria-busy', String(items.length > 0));
    const jobs = items.slice(0, visible).map(item => {
      const placeholder = document.createElement('div');
      placeholder.className = 'mus-favourite-card mus-favourite-card--loading';
      placeholder.textContent = strings.loading;
      grid.append(placeholder);
      return {item, placeholder};
    });
    let next = 0;
    async function worker() {
      while (next < jobs.length && version === renderVersion) {
        const {item, placeholder} = jobs[next++];
        let card;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const url = productUrl(item);
          url.searchParams.set('section_id', 'mus-favourite-item');
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', signal: controller.signal});
          if (!response.ok) { const error = new Error(); error.missing = response.status === 404; throw error; }
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          card = doc.querySelector('[data-mus-fav-item]');
          if (!card || card.dataset.productId !== String(item.id) || (item.variant && card.dataset.variantId !== String(item.variant))) {
            const error = new Error(); error.missing = true; throw error;
          }
        } catch (error) { card = errorCard(item, error.missing); }
        finally { clearTimeout(timeout); }
        if (version !== renderVersion) return;
        card.dataset.favouriteKey = identity(item);
        const heart = card.querySelector('[data-mus-favourite]');
        if (heart) {
          heart.removeAttribute('data-mus-favourite');
          heart.setAttribute('data-mus-fav-remove', '');
          heart.setAttribute('aria-pressed', 'true');
          heart.setAttribute('aria-label', strings.remove);
          heart.hidden = false;
        }
        placeholder.replaceWith(card);
      }
    }
    await Promise.all(Array.from({length: Math.min(4, jobs.length)}, worker));
    if (version === renderVersion) grid.setAttribute('aria-busy', 'false');
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-mus-favourite]');
    if (toggle) {
      event.preventDefault();
      if (toggle.disabled) return;
      const item = itemFor(toggle), items = read(), id = identity(item);
      const active = items.some(saved => identity(saved) === id);
      if (!active && items.length >= 200) { announce(strings.limit); return; }
      if (!save(active ? items.filter(saved => identity(saved) !== id) : [item, ...items])) return;
      sync(); renderPage();
      return;
    }
    const remove = event.target.closest('[data-mus-fav-remove]');
    if (remove) {
      const card = remove.closest('[data-favourite-key]');
      if (!card) return;
      const nextFocus = card.nextElementSibling || card.previousElementSibling;
      if (!save(read().filter(item => identity(item) !== card.dataset.favouriteKey))) return;
      sync();
      renderPage().then(() => {
        const target = nextFocus?.dataset.favouriteKey;
        const sibling = target && Array.from(page.querySelectorAll('[data-favourite-key]')).find(node => node.dataset.favouriteKey === target);
        const focus = sibling?.querySelector('[data-mus-fav-remove]') || page.querySelector('.mus-favourites__continue');
        focus?.focus({preventScroll: true});
      });
    }
    if (event.target.closest('[data-mus-fav-more]')) { visible += 12; renderPage(); }
    if (event.target.closest('[data-mus-fav-retry]')) renderPage();
  });
  document.addEventListener('change', event => { if (event.target.closest('#MusProductForm')) setTimeout(sync, 0); });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { sync(); renderPage(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) { sync(); renderPage(); } });
  let pending = false;
  new MutationObserver(records => {
    const added = records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('[data-mus-favourite],[data-mus-fav-link]') || node.querySelector('[data-mus-favourite],[data-mus-fav-link]'))));
    if (added && !pending) { pending = true; requestAnimationFrame(() => { pending = false; sync(); }); }
  }).observe(document.body, {childList: true, subtree: true});
  sync();
  renderPage();
})();
